var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPath.includes('/userInfo'))?_c('div',[_c('Channel',{attrs:{"path":_vm.currentPath,"baseUrl":_vm.baseUrl}}),(_vm.showCmsPaths.includes(_vm.currentPath))?_c('CmsColumn'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }